﻿import { postAsync } from '@_api/_base';

const oncaptchaLoadCallback = function () {
  const grecaptcha = (window as any).grecaptcha;
  const registerButton = document.querySelector('.saig-o-signup-form__section-register button') as HTMLButtonElement;
  const disableCapcha = registerButton.dataset.disableCapcha;

  if (disableCapcha) {
    return;
  }

  grecaptcha.render('dvCaptcha', {
    sitekey: '6LeTP5UnAAAAAAeAOvHA8kKd51Dvqhfa__dZLiAq',
    //sitekey: '6LeIB8onAAAAAAuLwgUp2WL0dkUWBzVcefR756nE', // Dev key
    'expired-callback': captchaExpiryCallback,
    callback: captchaCallback,
  });
};
const captchaExpiryCallback = function () {
  const txtCaptcha = document.querySelector('[id*=txtCaptcha]')!;
  txtCaptcha.textContent = 'Captcha verification expired';
  window.signupFormStatus = { ...window.signupFormStatus, capchaVerify: false };
  window.dispatchEvent(new CustomEvent('verifyRegister'));
};
const captchaCallback = function (response: any) {
  const divCaptcha = document.getElementById('dvCaptcha');
  const url = divCaptcha?.dataset.url;

  postAsync(url ?? '/en-au/api/UserAccount/VerifyCaptcha', undefined, `"${response}"`).then((res) => {
    const txtCaptcha = document.querySelector('[id*=txtCaptcha]')!;
    const captchaResponse = JSON.parse(res);
    if (captchaResponse.success) {
      txtCaptcha.textContent = captchaResponse.success;
      window.signupFormStatus = { ...window.signupFormStatus, capchaVerify: true };
      window.dispatchEvent(new CustomEvent('verifyRegister'));
    } else {
      txtCaptcha.textContent = 'Captcha verification failed';
    }
  });
};

const setupCaptcha = () => {
  const script = document.createElement('script');

  script.src = 'https://www.google.com/recaptcha/api.js?onload=oncaptchaLoadCallback&render=explicit';
  script.async = true;
  script.type = 'text/javascript';

  document.body.appendChild(script);
};
(window as any).captchaCallback = captchaCallback;
(window as any).oncaptchaLoadCallback = oncaptchaLoadCallback;

setupCaptcha();
export {};
